import {
  Box,
  Flex,
  Typography,
  Image,
  MediaBox,
  Picture,
} from "@jewlr/storybook/core"
import React from "react"

const BecauseIAmAGirl = () => (
  <Box contain lineHeight="copy" mb={1} pb={1}>
    <Box
      bg="primaryColors.oldlace"
      mb={1}
      p={1}
      px={{ desktop: "2em", widescreen: "10em" }}
      textAlign="center"
    >
      <Box mb={5} mt={4}>
        <Typography as="h1" fontWeight="normal" variant="h1">
          Because I am a Girl
        </Typography>
        <Typography
          as="p"
          fontSize={{ _: "1.3em", tablet: "1.5em" }}
          fontWeight="400"
          mt={{ tablet: "1.5em", widescreen: 2 }}
          px={{ tablet: "3em" }}
          variant="body1"
        >
          We are proud to sponsor Plan International’s{" "}
          <strong> Because I am a Girl initiative</strong>. Why? Because girls
          are awesome – yet every day around the world millions of girls are
          denied their basic human rights. Rights to education. Rights to
          nourishment. Rights to healthcare. Rights to protection.{" "}
          <i>And that’s not right</i>.
        </Typography>
      </Box>

      <Picture
        alt="Because I am a Girl"
        fallback={require("images/leefiori/info/because_I_am_a_girl/banner/desktop_2x.jpg")}
        pb="2em"
        px={{ desktop: "0px", tablet: "4em", widescreen: "4em" }}
        srcSet={[
          {
            media: "(max-width: 767px)",
            sizes: "355vw",
            srcSet: `
                          ${require("images/leefiori/info/because_I_am_a_girl/banner/mobile.jpg")} 355w,
                          ${require("images/leefiori/info/because_I_am_a_girl/banner/mobile_2x.jpg")} 710w
              `,
          },
          {
            media: "(min-width: 768px)",
            sizes: "885vw",
            srcSet: `
                          ${require("images/leefiori/info/because_I_am_a_girl/banner/desktop.jpg")} 830w,
                          ${require("images/leefiori/info/because_I_am_a_girl/banner/desktop_2x.jpg")} 1660w
              `,
          },
        ]}
        width="100%"
      />

      <Box m={{ tablet: "26px" }} px={{ tablet: "0px", widescreen: "7em" }}>
        <Typography
          as="p"
          fontSize={{ _: "1.1em", tablet: "1.5em" }}
          mb={{ _: "48px", tablet: 9 }}
          variant="body1"
        >
          Girls deserve the opportunity to become the women they aspire to be.{" "}
          <strong> Because I am a Girl </strong> supports girls to increase
          their confidence and change their own lives – so they can flourish and
          go on to improve the lives of those around them.
        </Typography>
      </Box>
      <Box mb={{ _: 5, tablet: 8 }}>
        <Flex
          //gutter={1}
          bg="white"
          flexDirection={{ _: "column", tablet: "row" }}
          id="secondBox"
          justifyContent={"space-evenly"}
        >
          <MediaBox
            lessThan="tablet"
            pb="8%"
            position={{ _: "relative" }}
            width="100%"
          >
            <Image
              alt="Girls Rights are human rights"
              left="0"
              position="absolute"
              px={3}
              src={require("images/leefiori/info/because_I_am_a_girl/tantinotes/mobile-girls-rights.svg")}
              top="-17px"
              width="100%"
            />
          </MediaBox>
          <Box flex="	0 1 45%" mt={{ _: 3, widescreen: 7 }}>
            {/* Green Dress image */}
            <Picture
              alt="Girls Rights are human rights"
              fallback={require("images/leefiori/info/because_I_am_a_girl/girls-rights/desktop_2x.jpg")}
              px={{ _: 1, tablet: 2 }}
              srcSet={[
                {
                  media: "(max-width: 767px)",
                  sizes: "355vw",
                  srcSet: `
              ${require("images/leefiori/info/because_I_am_a_girl/girls-rights/mobile.jpg")} 355w,
              ${require("images/leefiori/info/because_I_am_a_girl/girls-rights/mobile_2x.jpg")} 710w
            `,
                },
                {
                  media: "(min-width: 768px)",
                  sizes: "830vw",
                  srcSet: `
              ${require("images/leefiori/info/because_I_am_a_girl/girls-rights/desktop.jpg")} 830w,
              ${require("images/leefiori/info/because_I_am_a_girl/girls-rights/desktop_2x.jpg")} 1660w
            `,
                },
              ]}
              width={{ _: "100%", tablet: "90%" }}
            />
          </Box>
          <Box flex="	0 1 55%">
            {/* Desktop tantinotes text, hidden for mobile*/}
            <MediaBox
              greaterThanOrEqual="tablet"
              mb="110px"
              paddingBottom={5}
              position="relative"
              width="100%"
            >
              <Image
                alt="Girls Rights"
                left={{ desktop: "10%", tablet: "5%" }}
                position="absolute"
                src={require("images/leefiori/info/because_I_am_a_girl/tantinotes/desktop-girls-rights.svg")}
                top="-27px"
              />
            </MediaBox>
            <Box
              m={{
                _: "0",
                desktop: "38px",
                tablet: "27px",
                widescreen: "45px",
              }}
              mb={{ _: 4, tablet: "0px" }}
              mt={2}
              px={{ _: 1, tablet: "10%" }}
            >
              <Typography mb={2} variant="body3">
                <strong> Because I am a Girl </strong> is Plan International’s
                initiative that supports the youth-led movement for girls’
                rights and gender equality.{" "}
              </Typography>
              <Typography variant="body3">
                Plan international is standing with girls and young women by
                providing a platform, opportunities and support for them to
                become leaders and make change happen.
              </Typography>
            </Box>
            <Image
              alt="Because I Am A Girl"
              p={{ _: "0 60px 40px", tablet: "0 56px 48px 24px" }}
              src={require("images/leefiori/info/because_I_am_a_girl/I-am-a-girl-logo.svg")}
              width="100%"
            />
          </Box>
        </Flex>
      </Box>
    </Box>
  </Box>
)
export default BecauseIAmAGirl
